import script from "./ContextualMenuSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContextualMenuSelection.vue?vue&type=script&setup=true&lang=ts"

import "./ContextualMenuSelection.vue?vue&type=style&index=0&id=78103b13&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78103b13"]])

export default __exports__